import type { Day, TripConfig } from '../types';

export function homeTripSummary(trip: TripConfig, days: Day[]) {
  const countries = new Set(trip.destinations.map(d => d.country?.trim().toLowerCase()).filter(Boolean));
  const flights = new Set(days.flatMap(d => d.transports || [])
    .filter(t => t.mode?.toLowerCase() === 'flight')
    .map(t => t.id || [t.flightNum, t.dep, t.from, t.to].join('|')));
  return {
    days: days.length,
    destinations: trip.destinations.length,
    countries: countries.size,
    flights: flights.size,
  };
}
